export default __webpack_public_path__ + "static/media/img5.494ea624.png";